module.exports = __webpack_public_path__ + "img/23ne.5783269a.svg";